import { FetchSettingsRequestTypes } from '../actions/SettingsActions';
const initialState = {};

const Settings = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchSettingsRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data.toJS();
      }

    default:
      return state;
  }
};

export default Settings;